<template>
      <div class="Center">
        <div class="avatar" :class="`avatar-userlevel__${user.level}`">
          <img src="https://product-ssl-qiniu.bmtrip.com/rebuild_default_avatar.png" alt="" width="80" height="80" v-if="!user.head">
          <img :src="user.head+'?imageMogr2/gravity/Center/thumbnail/!80x80r/crop/80x80'" width="80" height="80" alt="" v-else>
          <vue-core-image-upload
            crop-ratio="1:1"
            crop="local"
            url="/api/v3/independ/upload/image"
            extensions="png,jpeg,jpg"
            compress="20"
            text="修改头像"
            langType="ZH"
            inputOfFile="image"
            :crop-btn="buttonText"
            @imageuploaded="cropLocalImageUploaded">
          </vue-core-image-upload>
          <div class="name">
            <p>{{user.username}}</p>
            <p class="user-level">{{levelText}}</p>
            <p class="user-score"><span>{{user.score}}</span> 积分</p>
          </div>
        </div>
        <ul class="center-nav">
          <router-link active-class="act" to="order">
            <li>我的订单</li>
          </router-link>
          <router-link active-class="act" to="travelPeople">
            <li>常用出行人</li>
          </router-link>
          <router-link active-class="act" to="collection">
            <li>线路收藏</li>
          </router-link>
          <router-link active-class="act" to="myInfo">
            <li>我的信息</li>
          </router-link>
          <router-link active-class="act" to="coupon">
            <li>
              优惠券
            </li>
          </router-link>
          <!--<router-link active-class="act" to="invation">-->
            <!--<li>邀请返现</li>-->
          <!--</router-link>-->
          <!-- <router-link active-class="act" to="mycoin">
            <li>我的金币</li>
          </router-link> -->
        </ul>
      </div>
</template>
<script type="text/javascript">
  import VueCoreImageUpload from 'vue-core-image-upload'
  import * as api from '@/api'
  import {mapGetters} from "vuex"
  export default {
    data () {
      return {
        head: '',
        user: {},
        buttonText: {
          ok: '确定',
          cancel: '取消'
        },
        // flag: true,
        pointMsg: {}
      }
    },
    components: {
      VueCoreImageUpload
    },
    props: {
      url: '',
      nickname: ''
    },
    methods: {
      cropLocalImageUploaded (res) {
        if (res.code === 0) {
          this.head = res.data.url
          this.user.head = this.head
          // console.log(this.head)
          // this.flag = false
          api.getInfo({head: this.head}).then(({data}) => {
            if (data.message) {
              this.$message({
                message: '头像已修改成功哦',
                type: 'success'
              })
              setTimeout(() => {
                window.location.reload()
              }, 1800)
            }
          }).catch((e) => {
            console.error(e)
          })
        }
      }
    },
    computed: {
      ...mapGetters({
         userInfo: 'userInfo'
      }),
      // user2 () {
      //   return this.user
      // },
      levelText () {
        switch (+this.user.level) {
          case 0: 
            return '注册用户'
          case 1: 
            return '白银会员'
          case 2: 
            return '黄金会员'
          case 3: 
            return '铂金会员'
          case 4: 
            return '钻石会员'
        }
      }
    },
    watch: {
      userInfo: {
        handler (value) {
          this.user = value
        },
        immediate: true
      }
    },
    created () {
//       api.getUserinfo().then((res) => {
//         if (res.data.code === 0) {
//           this.$store.commit('SET_USERINFO', res.data.data)
// //          console.log(res.data.data)
//           this.user = res.data.data
//           if (res.data.data.head !== '') {
//             this.flag = false
//           }
//         }
//       })
      this.$watch('nickname', (newVal, oldVal) => {
        this.user.username = newVal
      })
    }
  }
</script>
<style lang="less">
  @import "../../styles/theme.less";
      .Center{
        width:120px;
        height: 700px;
        .avatar{
          width:100%;
          // height: 165px;
          user-select: none;
          text-align:center;
          overflow: hidden;
          border-bottom:1px solid #e2e2e2;
          position: relative;
          &::after{
            content: "";
            width: 20px;
            height: 20px;
            position: absolute;
            right: 20px;
            top: 60px;
            border-radius: 50%;
            overflow: hidden;
          }
          &.avatar-userlevel__0::after{
            background: center no-repeat url('https://product-ssl-qiniu.bmtrip.com/icn_membership@3x.png');
            background-size: 100% 100%;
          }
          &.avatar-userlevel__1::after{
            background: center no-repeat url('https://product-ssl-qiniu.bmtrip.com/user-level-1.png');
            background-size: 100% 100%;
          }
          &.avatar-userlevel__2::after{
            background: center no-repeat url('https://product-ssl-qiniu.bmtrip.com/user-level-2.png');
            background-size: 100% 100%;
          }
          &.avatar-userlevel__3::after{
            background: center no-repeat url('https://product-ssl-qiniu.bmtrip.com/user-level-3.png');
            background-size: 100% 100%;
          }
          &.avatar-userlevel__4::after{
            background: center no-repeat url('https://product-ssl-qiniu.bmtrip.com/user-level-4.png');
            background-size: 100% 100%;
          }
          img{
            border-radius:50%;
            margin-bottom:8px;
          }
          .name{
            color:#20262E;
            line-height:24px;
            margin:10px 0 20px 0;
            .user-score {
              color: #898989;
              span {
                font-size: 16px;
                font-weight: 500;
              }
            }
            .user-level {
              display: inline-block;
              background: #C04374;
              color: #fff;
              padding: 0 6px;
              border-radius: 3px;
            }
          }
        }
        .center-nav{
          overflow: hidden;
          margin-top:16px;
          a{
            color: @primary-color;
            &:hover{
              text-decoration: underline;
            }
          }
          .act{
            color:rgba(52,60,69,.27);
          }
          li{
            width:100%;
            height:50px;
            text-align:center;
            line-height:50px;
            font-size:@grey-mlh1-size;
          }
        }
      }
  .g-core-image-upload-btn{
    color: @primary-color;
    font-size:11px;
  }

</style>



// WEBPACK FOOTER //
// src/components/center-nav/index.vue